import React, { useEffect, useState } from "react";
import styles from "./Redeem.module.sass";
import cn from "classnames";
import NFTModal from "../../components/NFTModal";
import { UseDisclosure } from "../../hooks/use-disclosure";
import Card from "../../components/Card";
import Table from "./Table";
import { UseApi } from "../../hooks/use-api";
import { GetRedeemList } from "../../Services/lib/admin";
import UPSAccount from "./UPSAccount";
import { useUser } from "../../context";
import redeem from "../../i11/Redeem";
const LIMIT = 8;

const Redeem = () => {
	const { locale } = useUser();
	const { isOpen, onClose, onOpen } = UseDisclosure();
	const {
		isOpen: isOpenUPS,
		onClose: oncCloseUPS,
		onOpen: onOpenUPS,
	} = UseDisclosure();
	const [nft, setNFT] = useState();

	const [page, setPage] = useState(1);
	const [total, setTotal] = useState(1);
	const [data, setData] = useState([]);

	const [{ isLoading }, getRedeemList] = UseApi({
		service: GetRedeemList,
	});

	const getList = async () => {
		setData([]);
		const res = await getRedeemList({
			limit: LIMIT,
			offset: (page - 1) * LIMIT,
		});
		if (res) {
			setData(res.data);
			setTotal(Math.ceil(res.count / LIMIT));
		}
	};

	useEffect(() => {
		getList();
	}, [page]);

	const close = () => {
		setNFT();
		getList();
		onClose();
	};

	const open = (data_) => {
		setNFT(data_);
		onOpen();
	};

	const prop = { data, getList, isLoading, page, setPage, total };

	return (
		<>
			<Card
				className={cn(styles.card, { [styles.hidden]: isOpen })}
				title={redeem[locale].redeems}
				classTitle={cn("title-purple", styles.title)}
				classCardHead={cn(styles.head, { [styles.hidden]: isOpen })}
				head={
					<button onClick={onOpenUPS} type="button" className="button-small">
						{redeem[locale].shipping_accounts}
					</button>
				}
			>
				<Table open={open} {...prop} />
			</Card>
			{nft && <NFTModal visible={isOpen} onClose={close} data={nft} redeem />}
			<UPSAccount isOpen={isOpenUPS} onClose={oncCloseUPS} />
		</>
	);
};

export default Redeem;
